export default __webpack_public_path__ + "static/principles-of-use-do-dark-a37c1f8017ffe01ab8e708f7769aa2d5.png";